import { BoxProps } from '@chakra-ui/react';
import { MBox } from '../chakra';
import MText from '../MText';

export const MCustomSelectTabItem = ({
  text,
  active,
  onClick,
}: {
  text: string;
  active: boolean;
  onClick: () => void;
} & BoxProps) => (
  <MBox
    role="button"
    onClick={onClick}
    px={2}
    py={2}
    cursor="pointer"
    fontSize="md"
    borderBottom={active ? '2px solid #4659da' : '2px solid transparent'}
  >
    <MText
      color={active ? 'tIndigo.base' : 'tPurple.base'}
      fontWeight={active ? 'bold' : 'unset'}
    >
      {text}
    </MText>
  </MBox>
);
